import React from 'react';
import SimulationApprovalUI from './SimulationApprovalUI';
import InterruptDisplay from './TimelineThinking/InterruptDisplay';
import {MessageInterrupt as MsgInterrupt} from "./types";

interface MessageInterruptProps {
  sseInterrupt: MsgInterrupt | null;
  interruptTags: any[];
  isSSEConnected: boolean;
  interruptLoading: boolean;
  showBigChatBox: boolean;
  onRespond: (responseType: string, responseData?: any, interruptId?: string, chatId?: string | number, messageId?: number) => void;
  isLastBotMessage?: boolean;
}

const MessageInterrupt: React.FC<MessageInterruptProps> = ({
  sseInterrupt,
  interruptTags,
  isSSEConnected,
  interruptLoading,
  showBigChatBox,
  onRespond,
  isLastBotMessage = false,
}) => {

  const sseInterruptData = sseInterrupt?.data;
  const interrupt_id = sseInterrupt?.data?.interrupt_id;
  const chat_id = sseInterrupt?.data?.chat_id;
  const message_id = sseInterrupt?.data?.message_id;

  if (!sseInterrupt && (!interruptTags || interruptTags.length === 0)) return null;

  return (
    <div className="message-interrupts mb-4">
      {sseInterrupt ? (
        sseInterrupt.type === 'simulation_approval_ui' ? (
          <SimulationApprovalUI
            interruptId={sseInterruptData.interrupt_id}
            workItemId={sseInterruptData.work_item_id}
            plan={sseInterruptData.plan || []}
            message={sseInterruptData.message || 'Please review this simulation plan:'}
            onApprove={() => onRespond('approve', {}, interrupt_id, chat_id, message_id)}
            onModify={(mod) => onRespond('modify', mod, interrupt_id, chat_id, message_id)}
            onCancel={() => onRespond('cancel', {}, interrupt_id, chat_id, message_id)}
            loading={interruptLoading}
            showBigChatBox={showBigChatBox}
            readOnly={!!sseInterruptData?.read_only || !isLastBotMessage}
          />
        ) : null
      ) : (
        interruptTags.map((interruptTag, idx) => (
          <InterruptDisplay
            key={`interrupt-tag-${idx}`}
            content={interruptTag.content}
            onInterruptResponse={onRespond}
            hasActiveSession={isSSEConnected}
            isLoading={interruptLoading}
            showBigChatBox={showBigChatBox}
          />
        ))
      )}
    </div>
  );
};

export default MessageInterrupt; 